import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const formularios = {
	state: {
		
	},
	getters: {

	},
	actions: {
		sendContacto : ({commit}, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/autocontact/contacto',data).then( result => {
					(result.data.status) ? resolve(true) : reject(false);
				}).catch(error => {
					reject(false);
				});  
			});	
		},
		sendTrabajaConNosotros : ({commit}, data)  => {
			return new Promise((resolve, reject) => {
				axios.post('/api/contacto',data).then( result => {
					(result.data == 1) ? resolve(true) : reject(false);
				}).catch(error => {
					reject(false);
				});  

			});
		},
		sendNewsletter : ({commit}, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/send-suscribe', data)
				.then(response => {
					(response.data.status) ? resolve(true) : reject(false);
				}
)				.catch(error => reject(error));
			});
		}
	},
	mutations: {
		
	}
}

export default formularios;



// WEBPACK FOOTER //
// ./src/store/formularios.js